import { useAppDispatch } from '@/globalStore/hooks.ts'
import { globalActions } from '@/globalStore/globalSlice/globalSlice.ts'
import { removeStoredTokens } from '@/core/utils/security.ts'
import { useNavigate } from 'react-router-dom'
import { frontPaths } from '@/config/frontPaths.ts'
import loginService from '@/modules/security/login/services/loginService'

const useUserMenuLogic = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleOnLogout = () => {
    removeStoredTokens()
    void loginService.logout()
    dispatch(globalActions.reset())
    navigate(frontPaths.security.login)
  }

  return { handleOnLogout }
}

export default useUserMenuLogic
